import {IGtmDataLayer, IGtmTrackingWindow} from '$shared/services/gtm/models/gtm-tracking';
import {CreateOrderResponseViewModel} from "$order-models/*";

type EcommerceDataLayer = IGtmDataLayer & {
    ecommerce?: IGtmDataLayer['ecommerce'] | null;
};

export const pushEcommerceEvent = (event: string, ecommerceData: any) => {
    if (typeof window === 'undefined') return;

    const trackingWindow = window as IGtmTrackingWindow;
    trackingWindow.dataLayer = trackingWindow.dataLayer || [];

    const clearEvent = { ecommerce: null } as unknown as EcommerceDataLayer;
    const ecommerceEvent = { event, ecommerce: ecommerceData } as EcommerceDataLayer;

    // console.log('[Ecommerce tracking]', event, ecommerceData);

    trackingWindow.dataLayer.push(clearEvent);
    trackingWindow.dataLayer.push(ecommerceEvent);
};

export const buildPurchaseFromReceipt = (
    receipt: CreateOrderResponseViewModel | any,
    orderLines: any[]
) => {
    if (!receipt || !orderLines?.length) return null;

    const currency =
        receipt.currency ||
        receipt.marketCurrency ||
        'DKK';

    const items = orderLines.map((line: any, index: number) => ({
        item_id:
            line.itemNumber ??
            line.originalItemNumber ??
            line.sanitizedItemNumber ??
            line.basketLineId ??
            `line-${index}`,
        item_name: line.itemDescription ?? 'Unknown product',
        item_brand: 'Kyocera',
        quantity: line.quantity ?? 1,
        price: line.unitPrice ?? 0,
    }));

    const value = items.reduce(
        (sum, item) => sum + (item.price || 0) * (item.quantity || 0),
        0
    );

    return {
        transaction_id: receipt.orderNumber ?? receipt.id ?? 'unknown-order',
        affiliation: 'Kyocera Unimerco Online',
        value,
        tax: receipt.taxAmount ?? 0,
        shipping: receipt.shippingAmount ?? 0,
        currency,
        coupon: receipt.couponCode || undefined,
        items,
    };
};